import { fromJS } from 'immutable'
import {
  REVENUE_PLANNING_SET_TABLE,
  REVENUE_PLANNING_EDIT_TABLE,
  REVENUE_PLANNING_SET_COMPLETE,
} from './../../constants'

const init = fromJS({
  isEdit: false,
  incompletedList: {},
  revenueTable: {
    expand: {},
  },
})

export default (state = init, action) => {
  switch (action.type) {
    case REVENUE_PLANNING_SET_TABLE:
      return state
        .set('revenueTable', action.payload)
    case REVENUE_PLANNING_EDIT_TABLE:
      return state
        .set('isEdit', action.payload)
    case REVENUE_PLANNING_SET_COMPLETE:
      return state
        .set('incompletedList', action.payload)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/project-information/revenue-planning-reducer.js